module.exports = __webpack_public_path__ + "static/media/plans-bg-logo-white.77d9a90b.svg";